export default `
  subscription OnCreateCardType($workflowId: String) {
    onCreateCardType(workflowId: $workflowId) {
      id
      title
      description
      color {
        red
        green
        blue
        rgb
      }
      showInBacklog
      generateWithAI
      domainModelRole
      defaultType
      order
      createdAt
    }
  }
`
